// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"24272e2a6654cce4d0be","661":"d497123caa1cb558ec3d","702":"77dd3b365b083246c720"}[chunkId] + ".bundle.js";
};